import React, { useState } from 'react';
import {
  PageContent,
  CompactTable,
  useFetch,
  User,
  useUserinfo,
} from '@mss/mss-component-library';
import Button from '../../../../../common/Button';
import { useParams, useHistory } from 'react-router-dom';
import columns from './columns';
import AddUserModal from './AddUserModal';
import Api from '../../../../services/Api';
import { useTranslation } from 'react-i18next';

type MembersProps = {
  superAdminGroup: boolean;
};

function Members({ superAdminGroup }: MembersProps) {
  const [hasPermission] = useUserinfo();
  const { groupId } = useParams<{ groupId: string }>();
  const [t] = useTranslation(['authorization', 'common']);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [mergedMemberInfo, setMergedMemberInfo] = useState<
    (User & { relationId: number })[]
  >([]);
  const [groupInfo, fetchGroupInfo] = useFetch({
    url: `/api/user/group/?user=&group=${groupId}`,
    defaultValue: [],
    onEmpty: () => setMergedMemberInfo([]),
    onSucces: async ({ data: shallowUsers }) => {
      const resp = await Api.user.all(parseInt(groupId));
      const fullUsers = await resp.json();
      const mergedMembers = fullUsers.map((x: User) => ({
        ...x,
        relationId: shallowUsers.find((y: any) => y.user === x.id).id,
      }));
      setMergedMemberInfo(mergedMembers);
    },
  });

  return (
    <PageContent
      title={t('Members')}
      actions={
        hasPermission('change_group') &&
        hasPermission('add_usergroup') && (
          <Button
            variant="primary"
            data-ta="AddUser"
            disabled={superAdminGroup}
            onClick={() => setShowModal(true)}
          >
            {t('ADD USER')}
          </Button>
        )
      }
    >
      <CompactTable
        dataSource={mergedMemberInfo}
        loading={groupInfo.loading}
        columns={columns(t, fetchGroupInfo, superAdminGroup, hasPermission)}
        rowKey="id"
        onRow={(record: any) => ({
          onClick: () => history.push(`/authorization/users/${record.id}/`),
        })}
        pagination={false}
        bordered={false}
        showHeader={false}
      />
      {showModal && (
        <AddUserModal
          groupId={groupId}
          fetchGroupMembers={fetchGroupInfo}
          closeModal={() => setShowModal(false)}
        />
      )}
    </PageContent>
  );
}

export default Members;
